interface SparkProps {
  data: number[]
  w?: number
  h?: number
  color?: string
}

export default function Spark({ data, w = 80, h = 30, color }: SparkProps) {
  const min = Math.min(...data)
  const max = Math.max(...data)
  const range = max - min || 1
  const points = data.map((v, i) => {
    const x = (i / (data.length - 1)) * w
    const y = h - ((v - min) / range) * (h - 4) - 2
    return [x, y] as [number, number]
  })
  const d = points.map((p, i) => (i === 0 ? 'M' : 'L') + p[0].toFixed(1) + ' ' + p[1].toFixed(1)).join(' ')
  return (
    <svg className="sc-spark" viewBox={`0 0 ${w} ${h}`} preserveAspectRatio="none">
      <path d={d} style={color ? { stroke: color } : undefined} />
    </svg>
  )
}
